import React from "react"

import { AppAntSwitch } from "@components"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { boolean, object } from "yup"


export default function ReportWebSuppliersExclusionSwitch() {
	const {
		filterWebSuppliersExclusion,
		setFilterWebSuppliersExclusionInfo,
	} = useReportFormInfo(reportFormData.peek().filterWebSuppliersExclusion, "filterWebSuppliersExclusion", object({ filterWebSuppliersExclusion: boolean() }))

	return <AppAntSwitch
		trueText="Exclude web suppliers"
		checked={!!filterWebSuppliersExclusion}
		onChange={e => setFilterWebSuppliersExclusionInfo(e.target.checked)}
	/>
}